import { render } from "./XIconSolidLayers.vue?vue&type=template&id=392e02ae"
import script from "./XIconSolidLayers.vue?vue&type=script&lang=js"
export * from "./XIconSolidLayers.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidLayers.vue"]])

export default __exports__